import PageBannerContext, { usePageBannerContext } from './PageBannerContext';

function PageBanner(props) {
  // Hooks
  const { renderBanner } = usePageBannerContext();

  return renderBanner(props);
}

export const PageBannerProvider = PageBannerContext.Provider;

export default PageBanner;
